export function isAnonymous(name: string): boolean {
   const ANONYMOUS = 'anonymous';
   return ANONYMOUS.localeCompare(name, undefined, { sensitivity: 'base' }) === 0;
}
